<template>
<div class="search-layout">
    <div>
        <input v-model="searchText" @keydown="debouncedRunSearch" @keydown.enter="enterRunSearch" @keydown.esc="cancelSearch" ref="search" type="text" placeholder="Search..." class="search-box no-border" @blur="lostFocus" :class="{showing: searchVisible}" />
    </div>
    <v-btn icon text @click="toggleSearchVisibility">
        <v-icon v-if="searchVisible">close</v-icon>
        <v-icon v-else>search</v-icon>
    </v-btn>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import Utilities from '../helpers/Utilities'

export default {
    data() {
        return {
            searchVisible: false,
            searchText: '',
        }
    },

    components: {
        
    },
    
    props: {
        item: Object,
        debounced: Boolean,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        clear() {
            this.searchText = ''
            this.runSearch()
        },

        debouncedRunSearch: Utilities.debounce( function() {
            if(this.debounced)
                this.runSearch()
        },700),

        enterRunSearch() {
            if(!this.debounced)
                this.runSearch()
        },

        runSearch() {
            // if(!this.searchText)
            //     return
            console.log('about to search for ', this.searchText)
            this.$emit('search', this.searchText.toLowerCase())
        },
        toggleSearchVisibility() {
            this.searchVisible = !this.searchVisible
            if(this.searchVisible)
                this.$refs.search.focus()
            else {
                this.cancelSearch()
            }
        },
        lostFocus() {
            setTimeout( () => {
                if(!this.searchText) {
                    this.cancelSearch()
                }

            },200)
        },
        cancelSearch() {
            this.searchVisible = false
            setTimeout( () => {

                this.searchText = ''
                this.$refs.search.blur()  
                this.$emit('search', '')          
            },100)
        },

    },

    created() {

    }
}
</script>

<style scoped>
   .search-box {
       background-color: rgba(255,255,255,.2);
       padding:5px 9px; border-radius:5px;
       opacity: 0; width:0px;
       transition: all .2s ease-in-out;
   }
   .search-box.showing {
       width: 200px; opacity:1
   }
   .search-box::placeholder {
       color: rgba(255,255,255,.4); 
   }

   .search-layout {
       display:flex;align-items:center
   }
</style>




// WEBPACK FOOTER //
// ToolbarSearch.vue?4eb359f4